// Radios por rol del design system (Nexvia App - Rediseño).
// Referenciados desde nexviaTheme.jsx en vez de hardcodear el literal en cada styleOverrides.
const radius = {
  pill: 999, // inputs, chips, botones
  button: 48, // border-radius base de Button (todas las variantes)
  card: 16, // cards de selección, chip "Paso", tarjetas de resumen
  panel: 24, // tarjetas de sección, paneles de formulario
};

export default radius;
